
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class DeliveryChallanItemsGrid extends Serenity.EntityGrid<DeliveryChallanItemsRow, any> {
        protected getColumnsKey() { return 'Sales.DeliveryChallanItems'; }
        protected getDialogType() { return DeliveryChallanItemsDialog; }
        protected getIdProperty() { return DeliveryChallanItemsRow.idProperty; }
        protected getInsertPermission() { return DeliveryChallanItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return DeliveryChallanItemsRow.localTextPrefix; }
        protected getService() { return DeliveryChallanItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true; 
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }

}